import { globalTheme } from "srs.sharedcomponents/lib/esm/styles/config";

export const customTheme = {
    colors: {...globalTheme.colors,
      sideBarActiveBackGroundColor: "#002469"
    },
  };